<div  class = "pd-5" >
    <h3 class="text-muted">Manage Vacation Days</h3>
</div>
<div  class = "pd-5" *ngIf="!!featureTags && !featureTags['set_vacation_date']">
    <button mat-raised-button [routerLink] = "['/account/recurring']">Back</button>
</div>
<div  class = "pd-5" id="addVacationBtn" *ngIf="!!featureTags && featureTags['set_vacation_date']">
    <button mat-raised-button color = "primary" (click)="addVacationDates($event)">Add Vacation</button>
</div>
<div class="text-center noVacationMessage" *ngIf="vacationDates.length === 0 && contentLoaded">
    <h4 class="text-muted text-center">There are no Vacation dates for you.</h4>
</div>
<mat-card class="subscription-container"  >
    <mat-card class="cart-card vacation" *ngIf="vacationDates.length > 0">
        <div fxLayout="row" fxLayoutAlign="start center">
            <p class="title vactionTitle">You have {{vacationDates.length}} active vacation(s).</p>
        </div>
    </mat-card>
    <!-- Vacation Skeleton Loader -->
    <div class="my-cart-card mt-1" *ngIf = "vacationDates.length === 0 && contentLoaded === false">
        <mat-card class="cart-card vacation">
            <div fxLayout="row" fxLayoutAlign="start center">
                <p class="title vactionTitle">Your Active Vacations</p>
            </div>
        </mat-card>
        <ngx-skeleton-loader
        count="5"
        ></ngx-skeleton-loader>
    </div>
    <div class="example-container" *ngIf="vacationDates.length > 0">
        <mat-table  [dataSource]="dataSource" >
        <ng-container matColumnDef="startDate">
            <mat-header-cell  *matHeaderCellDef fxHide.lt-sm="true"> Start Date </mat-header-cell>
            <mat-cell  *matCellDef="let element" data-label="startDate"> {{element.start_date | date : 'MM/dd/yyyy'}} </mat-cell>
        </ng-container>
        
        <ng-container matColumnDef="endDate">
            <mat-header-cell  *matHeaderCellDef fxHide.lt-sm="true"> End Date </mat-header-cell>
            <mat-cell  *matCellDef="let element" data-label="endDate"> {{element.end_date | date : 'MM/dd/yyyy'}} </mat-cell>
        </ng-container>
        
        <ng-container matColumnDef="comments">
            <mat-header-cell  *matHeaderCellDef fxHide.lt-sm="true"> Comments </mat-header-cell>
            <mat-cell  *matCellDef="let element" data-label="comments" class = "over-y word-break"> {{element.comments}} </mat-cell>
        </ng-container>
        
        <ng-container matColumnDef="action" class = "center">
            <mat-header-cell  *matHeaderCellDef class = "center" fxHide.lt-sm="true"> Action </mat-header-cell>
            <mat-cell  *matCellDef="let element" class = "center" data-label="action" fxLayoutGap = "5px"> 

                <button mat-raised-button color = "primary" (click) = "editVacation(element,$event)">Edit</button>
                <button mat-raised-button (click) = "deleteVacation(element,$event)">Delete</button>

            </mat-cell>
        </ng-container>
        
        <mat-header-row fxHide.lt-sm="true" *matHeaderRowDef="displayedColumns"></mat-header-row>
        <mat-row  *matRowDef="let row; columns: displayedColumns;"></mat-row>
        </mat-table>
    </div>
</mat-card>
